<app-navbar class="dark:bg-slate-800"></app-navbar>
<app-daily class="dark:bg-slate-800"></app-daily>
